import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { environment } from '../../../environments/environment';
import { Authority } from 'src/app/shared/constants/authority.constants';
import { AccountService } from './account.service';
import { Constant } from '../constant';

@Injectable({ providedIn: 'root' })
export class AuthServerProvider {
  constructor(
    private http: HttpClient, 
    private $localStorage: LocalStorageService, 
    private $sessionStorage: SessionStorageService,
    private accountService: AccountService,
    ) {}

  getToken() {
    const token = this.$localStorage.retrieve(Constant.key_local_token);
    return  token || this.$sessionStorage.retrieve(Constant.key_local_token);
  }

  login(credentials): Observable<any> {
    const data = {
      username: credentials.username,
      password: credentials.password,
      code: credentials.code,
      rememberMe: credentials.rememberMe
    };
    const formData = new FormData();
    formData.append('username', credentials.username);
    formData.append('password', credentials.password);
    return this.http.post(environment.SERVER_API_URL + 'login', formData, { observe: 'response' })
    .pipe(map((resp: any) => {
      const token = resp.headers.get('x-auth-token');
      this.$sessionStorage.store('token', token);
      const acc = resp.body || {};
      acc.adminGroup = acc.adminGroup || {};
      acc.authorities  = [Authority.EMPLOYEE];
      if (acc.adminGroup.code === 'ADMIN') {
        acc.isAdmin = true;
        acc.authorities.push(Authority.ADMIN);
      };
      this.$sessionStorage.store('profile', acc);
      this.accountService.authenticate(acc);

      return acc;
    }));
  }

  loginWithToken(jwt, rememberMe) {
    if (jwt) {
      this.storeAuthenticationToken(jwt, rememberMe);
      return Promise.resolve(jwt);
    } else {
      return Promise.reject('auth-jwt-service Promise reject'); // Put appropriate error message here
    }
  }

  storeAuthenticationToken(jwt, rememberMe) {
    if (rememberMe) {
      this.$localStorage.store(Constant.key_local_token, jwt);
    } else {
      this.$sessionStorage.store(Constant.key_local_token, jwt);
    }
  }

  logout(): Observable<any> {
    return new Observable(observer => {
      this.$localStorage.clear(Constant.key_local_token);
      this.$sessionStorage.clear(Constant.key_local_token);
      observer.complete();
    });
  }


  hasAnyAuthority(authorities: string[]): boolean {
    return true;
  }

  hasAuthority(authority: string): boolean {
    return true;
  }
}
